import { useTranslation } from "react-i18next";
import "../App.css";
import { Slider } from "./Slider";

function FixBottomHeight() {
  const { t } = useTranslation();

  return (
    <>
      <div id="fb-panel" className="panel-section">
        <div>
          <div className="section-header section">{t("fix_bottom_height")}</div>
          <div className="line"></div>
          <Slider
            idSlider={"fb-height"}
            tittle={t("height")}
            minSlider={30}
            maxSlider={150}
            stepSlider={10}
            iniValue={50}
            unit={t("unit")}
            editable={1}
            sliderOff={0}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <div className="section-header section">{t("wing_height")}</div>
          <div className="line"></div>
          <Slider
            idSlider={"wing-height"}
            tittle={t("height")}
            minSlider={70}
            maxSlider={180}
            stepSlider={10}
            iniValue={130}
            unit={t("unit")}
            editable={1}
            sliderOff={0}
          />
        </div>
      </div>
    </>
  );
}

export default FixBottomHeight;
